<template>
    <card-columns-section
        class="card-columns-section-module"
        :columns="columns"
    />
</template>

<script>
    import CardColumnsSection from '../../../organisms/CardColumnsSection/CardColumnsSection';
    import formatMediaObject from '../../../../utils/formatters/format-media-object';

    export default {
        name: 'card-columns-section-module',

        components: { CardColumnsSection },

        props: {
            attributes: {
                type: Object,
                default: () => ({}),
            },
        },

        computed: {
            /**
             * Return the formatted columns.
             *
             * @returns {Array}
             */
            columns() {
                return this.attributes.columns.map(({ id, text, image }) => ({
                    id,
                    text,
                    image: formatMediaObject
                        .call(this, image),
                }));
            },
        },
    };
</script>
